// extracted by css-extract-rspack-plugin
export default {"counter":"counter-tyQiBv","count":"count-A3i2cH"};